import { formatTimeInSeconds } from "./formatTimeInSeconds";

export declare namespace Header {
  export interface Props {
    onClickInfo: () => void;
    timerInSeconds: number;
  }
}

export function Header({ onClickInfo, timerInSeconds }: Header.Props) {
  const { minutes, seconds } = formatTimeInSeconds(timerInSeconds);

  return (
    <div className="flex flex-col">
      <div className="flex justify-center py-1 px-2 bg-gray-400/20 text-sm ">
        Not affiliated with Wordle
      </div>
      <div className="flex justify-end p-4 items-center text-gray-400">
        <div className="flex">
          <div className="w-10 tracking-wider text-right">{minutes}</div>
          <div className="mx-0.5">:</div>
          <div className="w-10 tracking-wider">{seconds}</div>
        </div>
        <button
          className="border border-gray-500 size-5 flex justify-center items-center text-sm font-mono cursor-pointer hover:bg-gray-700/40"
          onClick={onClickInfo}
        >
          i
        </button>
      </div>
    </div>
  );
}
